export default __webpack_public_path__ + "static/media/sara-socas.61c885be.png";